import { useFormikContext } from 'formik'
import Field from "../components/Field";
import React, { useEffect } from 'react'
import t from '../translate'
import i18n from '../i18n'

function DesiredCourseSelect ({ currentProgram, locations }) {
  let { setFieldValue } = useFormikContext()

  const handleCourseChange = (event) => {
    const selected = currentProgram?.courses?.find(
      c => String(c.code) === String(event.target.value)
    );
    
    setFieldValue('program.desiredCourse.code', event.target.value);

    if (selected) {
      setFieldValue('program.desiredCourse.text', `Standort ${selected.standort} » Kursstart ${new Date(selected.start_datum).toLocaleDateString('de-DE')}`);
      setFieldValue('program.desiredCourse.value', {
          location: selected.standort,
          startDate: new Date(selected.start_datum).toLocaleDateString('de-DE')
      });
    } else {
      setFieldValue('program.desiredCourse.text', '');
      setFieldValue('program.desiredCourse.value', {
          location: '',
          startDate: ''
      });
    }
  };

  return <>
    <div className="select-wrapper mb-4">
      <Field as="select" id="program.desiredCourse.code" name="program.desiredCourse.code" className="form-control" onChange={handleCourseChange}>
        <option value="">---</option>
        {currentProgram?.courses && currentProgram.courses.map(course => (
          <option key={course.code} value={course.code}>
            Standort {course.standort + ' » Kursstart ' + new Date(course.start_datum).toLocaleDateString('de-DE')}
          </option>
        ))}
      </Field>
    </div>
  </>
}

function Remarks ({currentProgram}) {
 return (
    <>
      {currentProgram && 
        ['Mediation', 'Business Coach', 'Systemischer Business Coach', 'Systemischer Business Coach - Schwerpunkt Online-Coaching']
          .includes(currentProgram?.bezeichnung) && (
            <>
              <h3 className="mb-4">
                {currentProgram.bezeichnung === 'Mediation' && (
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        "Ich möchte zusätzlich an dem folgenden Aufbaukurs teilnehmen. Bitte beachten Sie, dass zusätzliche Kosten entstehen können. Weitere Informationen dazu finden Sie in der nachfolgenden Abbildung. <a href='https://www.wings.hs-wismar.de/de/weiterbildung/mediation/kosten' target='_blank' rel='noopener noreferrer' style='color: #ff8200'>Kostenübersicht</a>"
                    }}
                  />
                )}
                {currentProgram.bezeichnung === 'Systemischer Business Coach' && (
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        "Ich möchte zusätzlich an dem folgenden Aufbaukurs teilnehmen. Bitte beachten Sie, dass zusätzliche Kosten entstehen können. Weitere Informationen dazu finden Sie in der nachfolgenden Abbildung. <a href='https://www.wings.hs-wismar.de/de/weiterbildung/ausbildung_business_coach/kosten' target='_blank' rel='noopener noreferrer' style='color: #ff8200'>Kostenübersicht</a>"
                    }}
                  />
                )}
                {['Business Coach', 'Systemischer Business Coach - Schwerpunkt Online-Coaching']
                  .includes(currentProgram.bezeichnung) && t('program.remark.label')}
              </h3>
            </>
      )}

      {currentProgram?.remarks && 
        <>
          {currentProgram.remarks.map((remark, idx) => (
            <Remark key={idx + 1} text={remark} idx={idx + 1} />
          ))}
          <Remark key={0} text={t('program.remark.default')} idx={0} />
        </>
      }
    </>
 );
}

function Remark ({text, idx}) {
  return (
    <>
      <div key={idx} className="form-radio">
        <Field
          type="radio"
          id={`program.remark.${idx}`}
          name={`program.remark.text`}
          value={text}
          className="form-control"
        />
        <label htmlFor={`program.remark.${idx}`}>
          {text}
        </label>
      </div>
    </>
  );
}

function PriceItem({price, idx}) {
  return (
    <div key={idx} className="form-checkbox">
      <Field
        id={`program.price.${idx}` || idx}
        type="checkbox"
        name={`program.price.${idx}` ||idx}
      />
      <label htmlFor={`program.price.${idx}`}>
        {price.preisgruppe} - {price.beschreibung} ({price.preis.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} {price.preiseinheit})
      </label>
    </div>
  );
}

export default function ProgramStep ({
  programs,
  onProgramChange,
  currentProgram,
  locations
}) {
  let { values, setFieldValue } = useFormikContext()

  function getProgramTitle (program) {
    return program.price 
      ? `${program.bezeichnung} (${program.price})` 
      : program.bezeichnung;
  }

  const handleProgramChange = (event) => {
    const selectedOption = event.target.options[event.target.selectedIndex];
    const code = selectedOption.getAttribute('data-code');
    const priceId = selectedOption.getAttribute('data-priceid');
    const price = selectedOption.getAttribute('data-price');

    setFieldValue('program.id', event.target.value)
    setFieldValue('program.code', code)
    setFieldValue('program.desiredCourse', "")
    setFieldValue('program.remark', {})
    onProgramChange(code, values)
  };

  const programNote = t('program.note');

  return <>
    <h3>{t('program.title')}</h3>
    <div className="select-wrapper mb-4">
      <Field as="select" name="program.id" onChange={handleProgramChange}>
        <option key="#" value="">--</option>
        {programs.map((program, idx) => (
          <option key={idx} 
                  value={`${program.code}`}
                  data-code={program.code} 
                  data-priceid={program.priceId}
                  data-price={program.price}
          >
            {getProgramTitle(program)}
          </option>
        ))}
        {}
      </Field>
    </div>

    {currentProgram?.prices && <>
      {currentProgram.prices.map((price, idx) => (
        <label key={`price-${idx}`} htmlFor={`program.price.${idx}`}>
          {price.preisgruppe} {price.preis.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} {price.preiseinheit}
        </label>
      ))}
    </>}

    {currentProgram && 
        ['Senior Business Coach', 'Online-Coach'].includes(currentProgram?.bezeichnung) && (
          <>
            <label style={{'marginTop':'10px'}}>
              Die Zulassungsvoraussetzung ist eine abgeschlossene Coachingausbildung. Haben Sie diese bereits erfolgreich absolviert? Falls nicht, wählen Sie <b>Systemischer Business Coach</b>.
            </label>
          </>
    )}

    {currentProgram && ['Wirtschaftsmediation', 'Familienmediation'].includes(currentProgram?.bezeichnung) && (
        <>
          <label style={{'marginTop':'10px'}}>
            Die Zulassungsvoraussetzung ist eine Mediationsausbildung. Haben Sie diese bereits erfolgreich absolviert? Falls nicht, wählen Sie <b>Mediation</b>.
          </label>
        </>
    )}

    <h3>{t('program.semester.title')}</h3>  
    {currentProgram && currentProgram.courses && <DesiredCourseSelect currentProgram={currentProgram} locations={locations}/>}

    <Remarks currentProgram={currentProgram}/>
  </>
}
